import Discover from "../../components/re-usable/discover/discover";
import RegulatoryFocusAndExchange from "./regulatoryFocusAndExchange";
import NewsAndEvents from "./news-and-events";
import RapsHighlights from "./raps-highlights";
import CalendarEvents from "./event-calendar";
import HeroSlider from "./hero-slider";
import HomeGoogleAds from "../../components/advertisement/home-google-ads";
import SecondaryNav from "../../components/secondary-nav/secondary-nav";
import { useEffect, useMemo, useState } from "react";
import LoadHomeGoogleAds from "../../components/advertisement/load-home-google-ads";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import LoadingComp from "../../components/re-usable/loading/loading";
import { useAppDispatch, RootState } from "../../redux/store";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import HomepageStyles from "./homepage.styles";

const Home = (): JSX.Element => {
  const path = "Home";

  const dispatch = useAppDispatch();

  const cachedGoogleAds = useMemo(() => <HomeGoogleAds />, []);
  const cachedUseDfpSlot = useMemo(() => <LoadHomeGoogleAds />, []);

  // Page published check
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [isPublished, setIsPublished] = useState(false);

  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  useEffect(() => {
    if (isPublished) {
      if (RapsEuropeData[0].result[0]?.javaScriptField)
        setScriptHtmlString(RapsEuropeData[0].result[0]?.javaScriptField);
    }
    if (typeof window !== "undefined" && window.runGlobalScripts) {
      window.runGlobalScripts();
    }
  }, [isPublished])

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>Regulatory Affairs Professionals Society | RAPS</title>
        <meta name="description" content="RAPS is the largest global organization of and for those involved with the regulation of healthcare and related products, including medical devices, pharmaceuticals, biologics and nutritional products." /> 
        <link rel="canonical" href="https://www.raps.org/" />
      </Helmet>
      <HomepageStyles />
      <SecondaryNav />
      <HeroSlider />
      <div className="homepage">
        <Discover />

        {/* News And Events */}
        <NewsAndEvents />

        {/* Raps Highlights */}
        <RapsHighlights />

        {/* Regulatory Focus */}
        <RegulatoryFocusAndExchange />

        {/* CalendarEvents */}
        <CalendarEvents />

        <div className="container">
          <p>&nbsp;</p>
          {cachedGoogleAds}
          {cachedUseDfpSlot}
          <p>&nbsp;</p>
        </div>
      </div>
    </>
  );
};

export default Home;
